import actions from "./actions";
import getters from "./getters";

const state = {
  featureRequests: [],
  loading: false,
  currentPage: 1,
  pageSize: 10,
  sortOrder: "votes", // 'votes' or 'recent'
  pagination: {
    current_page: 1,
    total_pages: 0,
    total_items: 0,
    page_size: 10,
  },
  votedRequestIds: [], // Track IDs of requests the user has voted on
};

const mutations = {
  SET_FEATURE_REQUESTS(state, requests) {
    state.featureRequests = requests;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_CURRENT_PAGE(state, page) {
    state.currentPage = page;
  },
  SET_SORT_ORDER(state, sort) {
    state.sortOrder = sort;
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = pagination;
  },
  UPDATE_FEATURE_REQUEST(state, updatedRequest) {
    const index = state.featureRequests.findIndex(
      (req) => req.id === updatedRequest.id
    );
    if (index !== -1) {
      state.featureRequests.splice(index, 1, updatedRequest);
    }
  },
  ADD_VOTED_REQUEST(state, requestId) {
    if (!state.votedRequestIds.includes(requestId)) {
      state.votedRequestIds.push(requestId);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
